import { makeStyles } from '@mui/styles';

const useStyles = makeStyles(
  (theme) => ({
    applyCreditModalContent: {
      display: 'flex',
      flexDirection: 'column',
      height: '100%',
      overflowX: 'hidden',
      overflowY: 'auto',
      maxWidth: '100%',
    },
    applyCreditModalMainContent: {
      display: 'flex',
      flexDirection: 'column',
      padding: '50px 40px 50px 40px',
      gap: '20px',
      flex: 1,
      maxWidth: '100%',
      boxSizing: 'border-box',
      [theme.breakpoints.down('md')]: {
        padding: '20px 20px 20px 20px',
      },
    },
    applyCreditModalTitle: {
      color: '#1A1919',
      fontSize: '36px',
      fontStyle: 'normal',
      fontWeight: 500,
      lineHeight: '24px',
      marginBottom: '10px',
      margin: 0,
      padding: 0,
      [theme.breakpoints.down('md')]: {
        lineHeight: 'normal',
      },
    },
    applyCreditModalDescription: {
      color: '#505050',
      fontSize: '14px',
      fontStyle: 'normal',
      fontWeight: 400,
      lineHeight: 'normal',
    },
    applyCreditModalInputSection: {
      display: 'flex',
      flexDirection: 'column',
      gap: '8px',
      padding: '35px 0px',
    },
    applyCreditModalInputRow: {
      display: 'flex',
      alignItems: 'flex-start',
      gap: '40px',
      maxWidth: '100%',
      boxSizing: 'border-box',
      [theme.breakpoints.down('md')]: {
        gap: '20px',
        flexWrap: 'wrap',
      },
    },
    applyCreditModalLabel: {
      color: 'var(--Smoke, #6E6E6D)',
      fontSize: '16px',
      fontStyle: 'normal',
      fontWeight: 400,
      lineHeight: 'normal',
      paddingTop: '10px',
      flexShrink: 0,
      minWidth: 'fit-content',
    },
    applyCreditModalInputContainer: {
      display: 'flex',
      flexDirection: 'column',
      position: 'relative',
      //   paddingBottom: '20px',
      minWidth: '300px',
      flex: 1,
      maxWidth: '100%',
      boxSizing: 'border-box',
      [theme.breakpoints.down('md')]: {
        minWidth: 0,
        width: '100%',
        flex: '1 1 100%',
      },
    },
    applyCreditModalErrorText: {
      position: 'absolute',
      top: '100%',
      left: 0,
      marginTop: '4px',
      color: '#D93636',
      fontSize: '12px',
      fontStyle: 'normal',
      fontWeight: 400,
      lineHeight: 'normal',
      opacity: 0,
      animation: '$fadeIn 0.3s ease-in-out forwards',
    },
    '@keyframes fadeIn': {
      from: {
        opacity: 0,
        transform: 'translateY(-4px)',
      },
      to: {
        opacity: 1,
        transform: 'translateY(0)',
      },
    },
    applyCreditModalInput: {
      width: '100%',
      '& .MuiInput-input': {
        fontSize: '16px',
        padding: '12px 16px',
      },
    },
    applyCreditModalCurrency: {
      color: '#1A1919',
      fontSize: '16px',
      fontWeight: 400,
    },
    applyCreditModalBalanceRow: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
    },
    applyCreditModalBalanceLabel: {
      color: '#505050',
      fontSize: '16px',
      fontStyle: 'normal',
      fontWeight: 500,
      lineHeight: 'normal',
    },
    applyCreditModalBalanceAmount: {
      color: '#1A1919',
      fontSize: '16px',
      fontStyle: 'normal',
      fontWeight: 400,
      lineHeight: 'normal',
    },
    applyCreditModalButtonContainer: {
      display: 'flex',
      justifyContent: 'space-between',
      padding: '20px 0px',
      borderTop: '1px solid #F0F0F0',
    },
    applyCreditModalButtonSection: {
      display: 'flex',
      padding: '0px 20px',
      justifyContent: 'space-between',
      width: '100%',
      maxWidth: '100%',
      boxSizing: 'border-box',
      gap: '12px',
    },

    applyCreditModalCancelButton: {
      width: '109px',
      height: '40px',
      border: '1px solid #DCDCDB',
      color: '#505050',
      lineHeight: '24px',
      fontSize: '15px',
      fontWeight: 500,
      textTransform: 'none',
      '&:hover': {
        border: '1px solid #DCDCDB',
        backgroundColor: '#F5F5F5',
      },
    },
    applyCreditModalApplyButton: {
      width: '126px',
      height: '40px',
      borderRadius: '100px',
      backgroundColor: '#FAD14C',
      border: 'none',
      textTransform: 'none',
      color: '#313131',
      fontSize: '15px',
      fontStyle: 'normal',
      fontWeight: 400,
      lineHeight: '24px',
      '&:hover': {
        backgroundColor: '#FAD14C',
      },
    },
  }),
  { name: 'ApplyCreditModal' },
);

export const getModalStyles = (breakpointMdDown) => ({
  container: {
    padding: '15px 15px 0px 15px',
  },
  content: {
    width: breakpointMdDown ? '100%' : '640px',
    maxWidth: breakpointMdDown ? '90vw' : '640px',
    height: breakpointMdDown ? 'auto' : '439.209px',
    maxHeight: breakpointMdDown ? '90vh' : '439.209px',
    borderRadius: breakpointMdDown ? '16px' : '24px',
    background: '#FFF',
    lineHeight: 'normal',
    boxShadow: '0 4px 6.1px 0 rgba(174, 174, 174, 0.25)',
    overflow: breakpointMdDown ? 'hidden' : 'hidden',
    overflowY: breakpointMdDown ? 'auto' : 'hidden',
    overflowX: 'hidden',
    padding: 0,
    boxSizing: 'border-box',
  },
});

export const getModalInputStyles = (breakpointMdDown) => ({
  maxWidth: breakpointMdDown ? '90%' : '640px',
  width: '640px',
  overflow: 'hidden',
});

export const getApplyButtonStyles = () => ({
  button: {
    border: 'none',
  },
});

export default useStyles;
